<template>
  <div>
    <div class="columns">
      <div
        v-if="data.topic === 'nameTitle'"
        class="column"
      >
        <b-field id="title">
          <div data-test="edit-kyc-authorized-representative--title-radio">
            <b-radio
              v-validate="'required'"
              v-model="form.nameTitle"
              native-value="Mr."
              name="title"
            >
              {{ $t('kyc.mr') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.nameTitle"
              native-value="Miss."
              name="title"
            >
              {{ $t('kyc.miss') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.nameTitle"
              native-value="Mrs."
              name="title"
            >
              {{ $t('kyc.mrs') }}
            </b-radio>
          </div>
        </b-field>
        <span class="is-invalid">{{ errors.first('title') }}</span>
      </div>
      <div
        v-if="data.topic === 'firstNameInThai'"
        class="column"
      >
        <b-field id="first-name-thai">
          <b-input
            v-validate="'required'"
            v-model="form.firstNameInThai"
            :placeholder="$t('kyc.first_name_th')"
            name="first name (Thai)"
            data-test="edit-kyc-authorized-representative--first-name-thai-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('first name (Thai)') }}</span>
      </div>
      <div
        v-if="data.topic === 'lastNameInThai'"
        class="column"
      >
        <b-field id="last-name-thai">
          <b-input
            v-validate="'required'"
            v-model="form.lastNameInThai"
            :placeholder="$t('kyc.last_name_th')"
            name="last name (Thai)"
            data-test="edit-kyc-authorized-representative--last-name-thai-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('last name (Thai)') }}</span>
      </div>
    </div>
    <div class="columns">
      <div
        v-if="data.topic === 'firstName'"
        class="column"
      >
        <b-field id="first-name">
          <b-input
            v-validate="'required'"
            v-model="form.firstName"
            :placeholder="$t('kyc.first_name')"
            name="first name"
            data-test="edit-kyc-authorized-representative--first-name-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('first name') }}</span>
      </div>
      <div
        v-if="data.topic === 'middleName'"
        class="column"
      >
        <b-field id="middle-name">
          <b-input
            v-model="form.middleName"
            :placeholder="$t('kyc.middle_name')"
            name="middle name"
            data-test="edit-kyc-authorized-representative--middle-name-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('middle name') }}</span>
      </div>
      <div
        v-if="data.topic === 'lastName'"
        class="column"
      >
        <b-field id="last-name">
          <b-input
            v-validate="'required'"
            v-model="form.lastName"
            :placeholder="$t('kyc.last_name')"
            name="last name"
            data-test="edit-kyc-authorized-representative--last-name-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('last name') }}</span>
      </div>
    </div>
    <div class="columns">
      <div
        v-if="data.topic === 'gender'"
        class="column"
      >
        <b-field id="gender">
          <div data-test="edit-kyc-authorized-representative--gender-radio">
            <b-radio
              v-validate="'required'"
              v-model="form.gender"
              native-value="Male"
              name="gender"
            >
              {{ $t('kyc.male') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.gender"
              native-value="Female"
              name="gender"
            >
              {{ $t('kyc.female') }}
            </b-radio>
          </div>
        </b-field>
        <span class="is-invalid">{{ errors.first('gender') }}</span>
      </div>
      <div
        v-if="data.topic === 'maritalStatus'"
        class="column"
      >
        <b-field id="marital-status">
          <div data-test="edit-kyc-authorized-representative--marital-status-radio">
            <b-radio
              v-validate="'required'"
              v-model="form.maritalStatus"
              native-value="Single"
              name="marital status"
            >
              {{ $t('kyc.single') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.maritalStatus"
              native-value="Married"
              name="marital status"
            >
              {{ $t('kyc.married') }}
            </b-radio>
          </div>
        </b-field>
        <span class="is-invalid">{{ errors.first('marital status') }}</span>
      </div>
    </div>
    <div class="columns">
      <div
        v-if="data.topic === 'birthdate'"
        class="column"
      >
        <b-field
          id="date-of-birth"
          data-test="edit-kyc-authorized-representative--birthdate"
        >
          <b-datepicker
            v-validate="'required|ageMoreThanTwenty'"
            v-model="form.birthdate"
            :mobile-native="false"
            :years-range="[-200, 200]"
            :placeholder="$t('kyc.click_to_select')"
            icon="calendar-today"
            name="date of birth"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('date of birth') }}</span>
      </div>
      <div
        v-if="data.topic === 'tel'"
        class="column"
      >
        <b-field
          id="phone-number"
          :label="$t('kyc.tel_number')"
        >
          <b-input
            v-validate="'required'"
            v-model="form.tel"
            :placeholder="$t('kyc.tel_placeholder')"
            name="phone number"
            data-test="edit-kyc-authorized-representative--phone-number-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('phone number') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthorizedRepresentative',
  inject: ['$validator'],
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Object,
      default: () => {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/SummaryOfKYC/components/AuthorizedRepresentative.vue